import Checkbox from './Checkbox'

import './style/css'

export default Checkbox
